import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash, faLock, faShieldHalved, faUserGroup, faClock, faBullhorn } from '@fortawesome/free-solid-svg-icons'

const features = [
  {
    icon: faEyeSlash,
    title: 'Anonimitas Penuh',
    desc: 'Identitas pelapor dijamin kerahasiaannya. Anda dapat melaporkan tanpa khawatir akan pembalasan.',
    color: 'text-blue-600',
    bg: 'bg-blue-50',
  },
  {
    icon: faLock,
    title: 'Enkripsi End-to-End',
    desc: 'Setiap data laporan dienkripsi dengan teknologi tinggi sehingga tidak dapat diakses pihak yang tidak berwenang.',
    color: 'text-indigo-600',
    bg: 'bg-indigo-50',
  },
  {
    icon: faShieldHalved,
    title: 'Perlindungan Pelapor',
    desc: 'Didukung regulasi perlindungan whistleblower sesuai peraturan perundang-undangan yang berlaku.',
    color: 'text-green-600',
    bg: 'bg-green-50',
  },
  {
    icon: faUserGroup,
    title: 'Tim Independen',
    desc: 'Laporan ditangani oleh tim independen yang terlatih dan bertanggung jawab langsung kepada Kepala Daerah.',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
  },
  {
    icon: faClock,
    title: 'Respons Cepat',
    desc: 'Setiap laporan ditargetkan mendapat respons dalam 14 hari kerja sejak laporan diterima dan diverifikasi.',
    color: 'text-rose-600',
    bg: 'bg-rose-50',
  },
  {
    icon: faBullhorn,
    title: 'Laporan Transparan',
    desc: 'Pelapor dapat memantau perkembangan laporan secara real-time menggunakan kode pelapor yang diberikan.',
    color: 'text-purple-600',
    bg: 'bg-purple-50',
  },
]

export default function FiturSection() {
  return (
    <section id="fitur" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-blue-600 text-sm font-bold uppercase tracking-widest">Keunggulan</span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-extrabold text-slate-900">Kenapa Percaya dengan WBS Kalsel?</h2>
          <p className="mt-4 text-slate-500 max-w-lg mx-auto">
            Dibangun dengan standar keamanan tinggi dan komitmen penuh terhadap perlindungan pelapor.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map(f => (
            <div key={f.title} className="bg-white border border-slate-100 hover:border-slate-200 hover:shadow-md rounded-2xl p-6 transition-all group">
              <div className={`w-12 h-12 ${f.bg} rounded-xl flex items-center justify-center mb-5`}>
                <FontAwesomeIcon icon={f.icon} className={`w-6 h-6 ${f.color}`} />
              </div>
              <h3 className="font-bold text-slate-800 text-lg mb-2">{f.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
